import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import PaginatedMenuView from '@/views/paginated_menu_view';
import template from '@/../templates/breadcrumb-product-item.hbs';

var globalCh = Radio.channel('global');

var ProductDropdown = PaginatedMenuView.extend( {
    className: 'ei-breadcrumb-content',
    initialize: function() {
        PaginatedMenuView.prototype.initialize.apply(this, arguments);
        this.on('select', this.change);
        this.collection.add( { id: 'view_all', name: 'View All Products' } );
    },
    ui: {
        toggle: '.dropdown-toggle',
        title: '.menu-title',
        menu_info: '.menu-info',
        actions: '.actions',
        next: '.actions .next',
        items: '.dropdown-menu.children',
        development: '.development',
        production: '.production',
        test: '.test',
        title_text: '.menu-title .text',
        test_zone_label: '.test-zone',
        development_zone_label: '.development-zone',
        production_zone_label: '.production-zone',
    },
    events: {
        'click @ui.next': 'fetch_next',
        'click @ui.title': 'click_title',
        'click @ui.test_zone_label': 'show_pre_production_devicegroups',
        'click @ui.development_zone_label': 'show_development_devicegroups',
        'click @ui.production_zone_label': 'show_production_devicegroups',
    },
    modelEvents: {'change': 'render'},
    template: Handlebars.compile(template),
    templateContext: function() {
        var primary = globalCh.request('primary_account');
        const active = globalCh.request('active_account');
        var data = {};
        data.show_pointer = false;
        if (this.getOption('area') === 'production' && active.permits(primary, 'view_production_devicegroups') ){
            data.production_area = true;
        } else if (this.getOption('area') === 'development' && active.permits(primary, 'view_development_devicegroups')) {
            data.development_area = true;
        } else if (this.getOption('area') === 'test' && active.permits(primary, 'view_pre_factoryfixture_devicegroups')) {
            data.test_area = true;
        }

        if ( this.getOption('show_pointer') ) {
            data.show_pointer = true;
        }

        data.show_development_zone = active.permits(primary, 'view_development_devicegroups');
        data.show_production_zone = active.permits(primary, 'view_production_devicegroups');
        data.show_test_zone = active.permits(primary, 'view_pre_factoryfixture_devicegroups');

        if ( active ) {
            data.show_toggle = active.permits(primary, 'view_development_devicegroups')
                || (active.permits(primary, 'view_production_devicegroups')
                || active.permits(primary, 'view_pre_production_devicegroups'));
        }
        return data;
    },
    click_title: function(e) {
        e.preventDefault();
        if ( e.which === 1 ) {
            this.change(this.model);
            return false;
        }
    },
    change: function(v5_object) {
        if ( v5_object.id === 'view_all'){
            this.show_all();
            return;
        }
        this.model = v5_object;
        this.set_active(this.model);
        this.menu_action(this.model);
    },
    set_active: function(v5_object) {
        var area = this.getOption('area');
        this.set_menu_title(v5_object.get('name'));

        this.children.each( function(child) {
            if ( child.model.get('id') === v5_object.get('id') ) {
                child.$('a').addClass('active');
            } else {
                child.$('a').removeClass('active');
            }
            if ( area === 'production' ){
                child.$('a').addClass('production');
            }
            if ( area === 'test' ) {
                child.$('a').addClass('test');
            }
        });
    },
    set_area: function(area){
        const active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        if ( !area || area === 'development'
            && active && active.permits(primary, 'update_development_devicegroup') ) {
                area = 'development';
        } else if ( !area || area === 'production'
            && active.permits(primary, 'update_production_devicegroup') ) {
                area = 'production';
        } else if ( !area || area === 'test'
            && active.permits(primary, 'update_test_factoryfixture_devicegroup') ) {
                area = 'test';
        } else {
            area = 'development';
        }

        this.ui[area].prop('checked', true);
    },
    onRender: function() {
        const active = globalCh.request('active_account');
        this.set_active(this.model);
        this.set_area(this.getOption('area'));
        this.ui.items.find('[data-id=view_all] a').addClass('view-all');
        this.ui.items.find('[data-id=view_all] a').attr('href', `/ide/${active.get('username')}/products`);
    },
    menu_action: function(v5_object) {
        let menu_action = v5_object.menu_action;
        if ( menu_action.indexOf('show_') > -1 ) {
            globalCh.request(v5_object.menu_action, v5_object);
        } else if ( this.getOption('area') === 'production') {
            globalCh.request('show_production_devicegroups', v5_object);
        } else if ( this.getOption('area') === 'test') {
            globalCh.request('show_pre_production_devicegroups', v5_object);
        } else {
            globalCh.request('show_development_devicegroups', v5_object, 'development_devicegroup');
        }
    },
    show_development_devicegroups: function(e) {
        e.preventDefault();
        if ( e.which === 1 ) {
            globalCh.request('show_development_devicegroups', this.model, 'development_devicegroup');
            return false;
        }
    },
    show_production_devicegroups: function(e) {
        e.preventDefault();
        const menu_action = this.getOption('menu_action');
        let action = '';
        if ( e.which === 1 ) {
            if ( menu_action.indexOf('production') > -1  || menu_action.indexOf('development') > -1 ) {
                action = 'show_production_devicegroups';
            } else if ( menu_action.indexOf('factory') > -1 ) {
                action = 'show_factory_devicegroups';
            } else if ( menu_action.indexOf('dut') > -1 ) {
                action = 'show_dut_devicegroups';
            }
            globalCh.request(action, this.model);
            return false;
        }
    },
    show_pre_production_devicegroups: function(e){
        e.preventDefault();
        const menu_action = this.getOption('menu_action');
        let action = '';
        if ( e.which === 1 ) {
            if ( menu_action.indexOf('production') > -1 || menu_action.indexOf('development') > -1 ) {
                action = 'show_pre_production_devicegroups';
            } else if ( menu_action.indexOf('factory') > -1 ) {
                action = 'show_pre_factoryfixture_devicegroups';
            } else if ( menu_action.indexOf('dut') > -1 ) {
                action = 'show_pre_dut_devicegroups';
            }
            globalCh.request(action, this.model);
            return false;
        }
    },
    show_all: function() {
        globalCh.request('showProducts');
    }
});

export default ProductDropdown;
